import { DirectionProvider as RadixDirectionProvider } from "@radix-ui/react-direction";
import type { ReactNode } from "react";

interface DirectionProviderProps {
  readonly children: ReactNode;
}

export function DirectionProvider({
  children,
}: DirectionProviderProps): ReactNode {
  return (
    <RadixDirectionProvider dir="rtl">{children}</RadixDirectionProvider>
  );
}
